import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const FaseNegociacionCierre = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/06-fase-negociacion-y-cierre.pdf`;
  /*const pdfUrl = "/pdf/06-fase-negociacion-y-cierre.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Fase de Negociación y Cierre</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Fase de Negociación y Cierre" />
      </Container>
    </>
  );
};

 export default FaseNegociacionCierre;
